import { useContext, useMemo } from 'react';
import MetricUsageLookupContext from '../contexts/MetricUsageLookupContext';
import metricTypeCheckers from '../types/metricTypeCheckers';

const useMetricUsageReport = (
  metric: Metrics.NormalMetric | Metrics.CompoundMetric | undefined,
) => {
  const { metricLookup, compoundMetricLookup } = useContext(
    MetricUsageLookupContext,
  );

  const usageReport = useMemo(() => {
    if (!metric) {
      return undefined;
    }

    if (metricTypeCheckers.isCompoundMetric(metric)) {
      return compoundMetricLookup[metric.id];
    } else {
      return metricLookup[metric.id];
    }
  }, [compoundMetricLookup, metric, metricLookup]);

  return usageReport;
};

export default useMetricUsageReport;
